import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { discountOffersAdd } from "../../../api/DiscountOffers";
import { batchList } from "../../../api/Batch";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import { SweetAlertShow, LoadingDiv } from "../../master/Master";
import AcademicPortalLayout from "../AcademicPortalLayout";

export default function DiscountOfferAdd() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [batches, setBatches] = useState([]);
  const [sessions, setSessions] = useState([]);

  const [formData, setFormData] = useState({
    session_id: "",
    batch_id: "",
    title: "",
    min_percentage: "",
    max_percentage: "",
    discount_type: "percentage",
    discount_percentage: "",
    discount_amount: "",
    last_date: "",
    remark: "",
  });

  const batchFetch = async () => {
    try {
      const response = await batchList(`session_id=${formData?.session_id}`);
      if (response.data.status) {
        setBatches(response?.data?.data);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    }
  };

  useEffect(() => {
    const parseSessions = JSON.parse(localStorage.getItem("sessions") ?? "[]");
    setSessions(parseSessions);

    const activeSession = parseSessions.find((s) => String(s.status) === "1");
    setFormData((prev) => ({
      ...prev,
      session_id: activeSession?.id || "",
    }));
  }, []);

  useEffect(() => {
    batchFetch();
  }, [formData?.session_id]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (Number(formData.min_percentage) > Number(formData.max_percentage)) {
      SweetAlertShow(
        "warning",
        "Warning",
        "Min % cannot be greater than Max %.",
      );
      return;
    }

    setLoading(true);
    try {
      const payload = new FormData(e.target);
      const response = await discountOffersAdd(payload);

      if (response.data.status) {
        SweetAlertShow("success", "Success", response.data.message);
        navigate("/discount/offers/list");
      } else {
        SweetAlertShow("warning", "Warning", response.data.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <AcademicPortalLayout />
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                        <h4 className="text-primary m-0">Add Discount Offer</h4>

                        <form onSubmit={handleSubmit}>
                          <div className="row">
                            <div className="col-md-6 mb-4">
                              <div className="form-floating form-floating-outline">
                                <select
                                  className="form-select"
                                  name="session_id"
                                  value={formData?.session_id}
                                  onChange={(e) =>
                                    setFormData({
                                      ...formData,
                                      session_id: e.target.value,
                                      batch_id: "",
                                    })
                                  }
                                  required
                                >
                                  <option value="">Select Session</option>
                                  {sessions?.map((session, index) => (
                                    <option key={index} value={session.id}>
                                      {session.session} :{" "}
                                      {session?.status === "1"
                                        ? "Active"
                                        : "Inactive"}
                                    </option>
                                  ))}
                                </select>
                                <label>Select Session</label>
                              </div>
                            </div>

                            <div className="col-md-6 mb-4">
                              <div className="form-floating form-floating-outline">
                                <select
                                  className="form-select"
                                  name="batch_id"
                                  value={formData?.batch_id}
                                  onChange={(e) =>
                                    setFormData({
                                      ...formData,
                                      batch_id: e.target.value,
                                    })
                                  }
                                  required
                                >
                                  <option value="">Select Batch</option>
                                  {batches?.map((batch) => (
                                    <option key={batch.id} value={batch.id}>
                                      {batch.title}
                                    </option>
                                  ))}
                                </select>
                                <label>Select Batch</label>
                              </div>
                            </div>

                            <div className="col-12 mb-4">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="text"
                                  className="form-control input-capitalize"
                                  placeholder="Offer Title"
                                  name="title"
                                  value={formData.title}
                                  onChange={(e) =>
                                    setFormData({
                                      ...formData,
                                      title: e.target.value,
                                    })
                                  }
                                  required
                                />
                                <label>Offer Title</label>
                              </div>
                            </div>

                            <div className="col-12">
                              <h6 className="text-muted mb-3">
                                Eligibility — Previous Year's Marks Range
                              </h6>
                            </div>

                            <div className="col-md-6 mb-4">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="number"
                                  className="form-control"
                                  min="0"
                                  max="100"
                                  name="min_percentage"
                                  placeholder="Min %"
                                  value={formData.min_percentage}
                                  onChange={(e) =>
                                    setFormData({
                                      ...formData,
                                      min_percentage: e.target.value,
                                    })
                                  }
                                  required
                                />
                                <label>Min Previous Year % Required</label>
                              </div>
                            </div>

                            <div className="col-md-6 mb-4">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="number"
                                  className="form-control"
                                  min="0"
                                  max="100"
                                  name="max_percentage"
                                  placeholder="Max %"
                                  value={formData.max_percentage}
                                  onChange={(e) =>
                                    setFormData({
                                      ...formData,
                                      max_percentage: e.target.value,
                                    })
                                  }
                                  required
                                />
                                <label>Max Previous Year % Required</label>
                              </div>
                            </div>

                            <div className="col-12">
                              <h6 className="text-muted mb-3">Discount</h6>
                            </div>

                            <div className="col-12 mb-3">
                              <div className="btn-group" role="group">
                                <button
                                  type="button"
                                  className={`btn ${
                                    formData.discount_type === "percentage"
                                      ? "btn-primary"
                                      : "btn-outline-primary"
                                  }`}
                                  onClick={() =>
                                    setFormData({
                                      ...formData,
                                      discount_type: "percentage",
                                    })
                                  }
                                >
                                  <i className="ri-percent-line me-1"></i>
                                  Percentage
                                </button>
                                <button
                                  type="button"
                                  className={`btn ${
                                    formData.discount_type === "fixed"
                                      ? "btn-primary"
                                      : "btn-outline-primary"
                                  }`}
                                  onClick={() =>
                                    setFormData({
                                      ...formData,
                                      discount_type: "fixed",
                                    })
                                  }
                                >
                                  <i className="ri-money-rupee-circle-line me-1"></i>
                                  Fixed Amount
                                </button>
                              </div>
                            </div>

                            <div className="col-md-6 mb-4">
                              <input
                                type="hidden"
                                name="discount_type"
                                value={formData.discount_type}
                              />
                              {formData.discount_type === "percentage" ? (
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="number"
                                    className="form-control"
                                    placeholder="Discount"
                                    name="discount_percentage"
                                    value={formData.discount_percentage}
                                    onChange={(e) =>
                                      setFormData({
                                        ...formData,
                                        discount_percentage: e.target.value,
                                      })
                                    }
                                    required
                                  />
                                  <label>Discount Percentage (%)</label>
                                </div>
                              ) : (
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="number"
                                    className="form-control"
                                    placeholder="Amount"
                                    name="discount_amount"
                                    value={formData.discount_amount}
                                    onChange={(e) =>
                                      setFormData({
                                        ...formData,
                                        discount_amount: e.target.value,
                                      })
                                    }
                                    required
                                  />
                                  <label>Discount Amount (₹)</label>
                                </div>
                              )}
                            </div>

                            <div className="col-md-6 mb-4">
                              <div className="form-floating form-floating-outline">
                                <textarea
                                  className="form-control"
                                  style={{ height: "100px" }}
                                  placeholder="Remark"
                                  name="remark"
                                  value={formData.remark}
                                  onChange={(e) =>
                                    setFormData({
                                      ...formData,
                                      remark: e.target.value,
                                    })
                                  }
                                ></textarea>
                                <label>Remark</label>
                              </div>
                            </div>
                          </div>

                          <div className="d-flex gap-2">
                            <button
                              type="submit"
                              className="btn btn-primary"
                              disabled={loading}
                            >
                              {loading ? (
                                <>
                                  <span
                                    className="spinner-border spinner-border-sm me-2"
                                    role="status"
                                  ></span>
                                  Saving...
                                </>
                              ) : (
                                "Save Offer"
                              )}
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
